import { IconAlertTriangle } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

import {
  useSuspenseGetAccounts,
  useSuspenseGetIwocapayPaymentLater,
} from '../../../api/lending/lapiHooks.suspense';
import { getOngoingPaymentPlans, getPaymentPlans } from '../Dashboard.helpers';

export const IsOverdueBanner = () => {
  const { accounts } = useSuspenseGetAccounts();
  const { buyerPayLinks } = useSuspenseGetIwocapayPaymentLater();

  if (!accounts?.accounts || !buyerPayLinks) return null;

  const paymentPlans = getPaymentPlans(accounts.accounts, buyerPayLinks);
  const isOverdue = getOngoingPaymentPlans(paymentPlans).some(
    (plan) => plan.status === 'overdue',
  );

  if (!isOverdue) return null;

  return (
    <AlertBox
      variant="failure"
      className="mb-l flex flex-col items-start gap-m !bg-structure-100 !p-l"
    >
      <div className="flex items-center gap-s">
        <IconAlertTriangle className="h-[20px] w-[20px] fill-core-65" />
        <p className="m-0 text-xl font-bold">You have some overdue payments</p>
      </div>
      <p className="m-0 text-m font-med">
        You'll need to settle any overdue payments before you can spread the
        cost of a new one.
      </p>
    </AlertBox>
  );
};
